import React from 'react';
import { Alert, Link, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useCanvasCourses } from 'controllers/react-query/canvasHooks';
import { Link as RouterLink } from 'react-router-dom';
import { useRedirectIfFeatureDisabled } from 'components/FeaturesContext';

export function CanvasListCourses() {
  useRedirectIfFeatureDisabled({ feature: 'show_canvas_courses', redirectTo: '/' });

  const { data, isError } = useCanvasCourses();

  if (isError) {
    return <Alert severity='error'>Error fetching Canvas courses</Alert>;
  }

  return (
    <Table sx={{ typography: 'bodyMedium' }}>
      <TableHead>
        <TableRow>
          <TableCell>Course Name</TableCell>
          <TableCell>Course Code</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.courses.map(course => (
          <TableRow>
            <TableCell sx={{ maxWidth: '240px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              <Link
                component={RouterLink}
                to={`/studio/canvas/courses/${course.id}`}
                sx={{ color: 'primary.main' }}
                data-testid={`course-create-link-${course.id}`}
              >
                {course.name}
              </Link>
            </TableCell>
            <TableCell sx={{ maxWidth: '240px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {course.course_code}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
